import { get, post, del } from './api';

export interface EditorPreset {
  id: number;
  presetId: string;
  name: string;
  nameEn: string | null;
  description: string | null;
  category: string;
  numberingSchemas: string;
  paragraphStyles: string | null;
  previewImage: string | null;
  sortOrder: number;
}

export interface EditorSchemaDTO {
  id: number;
  schemaId: string;
  userId: number;
  name: string;
  nameEn: string | null;
  sortOrder: number;
  sourcePresetId: string | null;
  description: string | null;
  numberingSchemas: string;
  paragraphStyles: string | null;
  meta: string | null;
  isSystem: number;
  isDefault: number;
  status: number;
  editableMaxLevels: string | null;
  selectedAbstractNumId: number;
  version: number;
  createdAt: string;
  updatedAt: string;
}

/** 获取系统预设模板列表 */
export async function getPresets(): Promise<EditorPreset[]> {
  const response = await get<EditorPreset[]>('/api/editor/presets');
  return response.data;
}

/** 获取当前用户的Schema列表 */
export async function getUserSchemas(): Promise<EditorSchemaDTO[]> {
  const response = await get<EditorSchemaDTO[]>('/api/editor/schemas');
  return response.data;
}

/** 保存Schema（新建或更新） */
export async function saveSchema(data: {
  schemaId?: string;
  name?: string;
  description?: string;
  numberingSchemas: any;
  paragraphStyles?: any;
  meta?: any;
  editableMaxLevels?: any;
  selectedAbstractNumId?: number;
}): Promise<EditorSchemaDTO> {
  // JSON 字段序列化为字符串
  const body = {
    ...data,
    numberingSchemas: typeof data.numberingSchemas === 'string' ? data.numberingSchemas : JSON.stringify(data.numberingSchemas),
    paragraphStyles: data.paragraphStyles ? (typeof data.paragraphStyles === 'string' ? data.paragraphStyles : JSON.stringify(data.paragraphStyles)) : undefined,
    meta: data.meta ? (typeof data.meta === 'string' ? data.meta : JSON.stringify(data.meta)) : undefined,
    editableMaxLevels: data.editableMaxLevels ? (typeof data.editableMaxLevels === 'string' ? data.editableMaxLevels : JSON.stringify(data.editableMaxLevels)) : undefined,
  };
  const response = await post<EditorSchemaDTO>('/api/editor/schemas', body);
  return response.data;
}

/** 重命名Schema */
export async function renameSchema(schemaId: string, name: string): Promise<EditorSchemaDTO> {
  const response = await post<EditorSchemaDTO>('/api/editor/schemas/rename', { schemaId, name });
  return response.data;
}

/** 删除Schema */
export async function deleteSchema(schemaId: string) {
  const response = await del<void>(`/api/editor/schemas/${schemaId}`);
  return response.data;
}
